import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AnalyticsRouteTracker } from "./analytics";
import { primePublicSiteBootstrap } from "./data/cms";
import "./styles.css";

async function start() {
  await primePublicSiteBootstrap(window.location.pathname);
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <BrowserRouter>
        <AnalyticsRouteTracker />
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );
}

void start();
